import { HEALTH_API } from 'constants/apiConstants';
import { HealthCheckStatus } from 'models/healthCheck';
import { BaseService } from '../baseService';

class HealthCheckService extends BaseService {
  private static instance: HealthCheckService;

  public static getInstance(): HealthCheckService {
    if (!HealthCheckService.instance) {
      HealthCheckService.instance = new HealthCheckService();
    }
    return HealthCheckService.instance;
  }

  public getStatus() {
    return this.get<HealthCheckStatus>(HEALTH_API.HealthCheckStatus, {
      validateStatus: (status: any) => status === 200 || status === 503,
    });
  }
}

export default HealthCheckService.getInstance();
